(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casida-daily-price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('casida-daily-price')) return;

    class CasidaDailyPrice extends HTMLElement {
      static number(value) {
        if (typeof value === 'string') {
          if (!/^[+-]?\d+(?:\.\d+)?$/.test(value.trim())) return NaN;
          value = Number(value);
        }
        return typeof value === 'number' && Number.isFinite(value) ? value : NaN;
      }

      static measurementFor(config, variant) {
        if (!variant?.id) return null;
        const entry = config.variants?.find((item) => String(item.variantId) === String(variant.id));
        if (entry) return entry.measurement;
        if (String(variant.id) === String(config.variant?.id)) return config.measurement;
        return variant.unit_price_measurement || null;
      }

      static calculate(config, measurement, priceCents, packs) {
        const number = this.number;
        if (config.doseType !== 'list.number_decimal' || !Array.isArray(config.dose) || config.dose.length === 0) return null;
        const doses = config.dose.map(number);
        if (doses.some((value) => !(value > 0))) return null;
        const dose = Math.min(...doses);
        if (!(number(priceCents) > 0) || !Number.isSafeInteger(packs) || packs < 1) return null;

        let contents;
        const hasCapsules = config.capsules !== null && config.capsules !== undefined && config.capsules !== '';
        if (hasCapsules) {
          contents = number(config.capsules);
          if (config.capsulesType !== 'number_integer' || !Number.isSafeInteger(contents) || contents < 1) return null;
        } else {
          contents = number(measurement?.quantity_value);
          if (!(contents > 0)) return null;
          if (measurement.quantity_unit === 'ml') contents /= 0.05;
          else if (measurement.quantity_unit !== 'g') return null;
        }

        const days = contents * packs / dose;
        const centsPerDay = priceCents / days;
        if (!Number.isFinite(days) || days <= 0 || !Number.isFinite(centsPerDay) || centsPerDay <= 0) return null;
        // Casida: Erst das Endergebnis runden; Auslöschung an einer halben Cent-Grenze abfangen.
        const roundedCents = Math.floor(centsPerDay + 0.5 + Number.EPSILON * centsPerDay * 4);
        return { days, centsPerDay, roundedCents, multipleDoses: doses.length > 1 };
      }

      connectedCallback() {
        // Casida: Auch bei nachgeladenen Sections erst das vollständige Element lesen.
        queueMicrotask(() => this.connect());
      }

      connect() {
        if (!this.isConnected || this.controller) return;
        try {
          this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
          this.formatter = new Intl.NumberFormat(this.config.locale || 'de-DE', {
            style: 'currency', currency: this.config.currency, minimumFractionDigits: 2, maximumFractionDigits: 2
          });
          const currencyDigits = new Intl.NumberFormat('en', { style: 'currency', currency: this.config.currency }).resolvedOptions().maximumFractionDigits;
          if (currencyDigits !== 2) return;
        } catch { return; }

        this.info = this.closest('.product__info');
        this.container = this.closest('.product-meta__price-list-container');
        if (!this.info || !this.container) return;
        this.variant = this.config.variant;
        this.measurement = CasidaDailyPrice.measurementFor(this.config, this.variant);
        this.badge = document.createElement('span');
        this.badge.className = 'casida-daily-price-badge';
        this.badge.hidden = true;
        this.badge.style.setProperty('--casida-daily-background', this.dataset.background || '#527e20');
        this.badge.style.setProperty('--casida-daily-color', this.dataset.color || '#ffffff');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        document.addEventListener('variant:changed', (event) => {
          if (event.target.getAttribute?.('id') !== this.dataset.formId) return;
          this.variant = event.detail?.variant || null;
          this.measurement = CasidaDailyPrice.measurementFor(this.config, this.variant);
          this.badge.hidden = true;
          this.schedule();
        }, options);
        this.info.addEventListener('casida:price:changed', (event) => {
          const list = this.container.querySelector('[data-product-price-list]');
          if (list) list.dataset.casidaPriceState = JSON.stringify(event.detail || {});
        }, options);
        for (const type of ['input', 'change']) {
          document.addEventListener(type, (event) => {
            if (event.target.form?.getAttribute('id') === this.dataset.formId || this.info.contains(event.target)) this.schedule();
          }, options);
        }
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => !this.badge.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.info, {
          childList: true, subtree: true, characterData: true, attributes: true,
          attributeFilter: ['data-casida-price-state', 'value', 'checked', 'selected']
        });
        this.schedule();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.badge?.remove();
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }

      displayedCents(priceNode) {
        // Casida: Nur Abgleich mit dem sichtbaren Preis; die Packungszahl kommt aus dem Preissystem.
        const copy = priceNode.cloneNode(true);
        copy.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach((node) => node.remove());
        let text = copy.textContent.replace(/[\s\u00a0\u202f]/g, '');
        const formats = [window.themeVariables?.settings?.moneyFormat, window.elbDevCustom?.moneyFormat].filter(Boolean);
        const comma = formats.length ? formats.some((format) => format.includes('comma_separator')) : this.config.locale?.startsWith('de');
        text = text.replace(/[^\d.,'-]/g, '');
        if (comma) text = text.replace(/[.']/g, '').replace(',', '.');
        else text = text.replace(/[,'\u2019]/g, '');
        const amount = CasidaDailyPrice.number(text);
        return amount > 0 ? Math.round(amount * 100) : NaN;
      }

      update() {
        this.badge.hidden = true;
        const list = this.container.querySelector('[data-product-price-list]');
        const priceNode = list?.querySelector(':scope > .price:not(.price--compare):not(.text--subdued)');
        if (!priceNode || !this.variant || list.hidden || getComputedStyle(list).display === 'none') return;
        if (priceNode.nextElementSibling !== this.badge) priceNode.after(this.badge);

        let state;
        try { state = JSON.parse(list.dataset.casidaPriceState || '{}'); } catch { return; }
        const number = CasidaDailyPrice.number;
        let priceCents = number(state.priceCents);
        let packs = number(state.coveredPacks);
        if (String(state.variantId) !== String(this.variant.id)) return;
        const visibleCents = this.displayedCents(priceNode);
        const form = document.getElementById(this.dataset.formId);
        const formData = form ? new FormData(form) : null;
        const planId = String(formData?.get('selling_plan') || '');

        if (planId) {
          if (String(state.sellingPlanId || '') !== planId) {
            const plan = this.config.variants.find((entry) => String(entry.variantId) === String(this.variant.id))?.allocations.find((entry) => String(entry.id) === planId);
            const quantity = number(formData?.get('quantity') || 1);
            if (!plan || !Number.isSafeInteger(quantity) || quantity < 1) return;
            const perDelivery = number(plan.perDeliveryPrice);
            const upfront = number(plan.price);
            if (!(perDelivery > 0) || !(upfront > 0)) return;
            // Casida: Standard-Abos und Vorauszahlung nur bei eindeutig passendem sichtbarem Betrag.
            if (visibleCents !== Math.round(upfront * quantity) && visibleCents !== Math.round(perDelivery * quantity)) return;
            priceCents = perDelivery * quantity;
            packs = quantity;
          } else if (visibleCents !== Math.round(priceCents)) return;
        } else {
          if (this.config.requiresSellingPlan || state.sellingPlanId) return;
          if (String(state.variantId) !== String(this.variant.id) || visibleCents !== Math.round(priceCents)) return;
        }

        const result = CasidaDailyPrice.calculate(this.config, this.measurement, priceCents, packs);
        if (!result) return;
        const amount = this.formatter.format(result.centsPerDay < 1 ? 0.01 : result.roundedCents / 100);
        let prefix = (result.centsPerDay < 1 ? this.dataset.under : this.dataset.prefix) || '';
        if (result.multipleDoses) {
          prefix = ['ab', prefix.replace(/^(Nur|Unter)\b/u, (word) => word.toLocaleLowerCase('de-DE'))].filter(Boolean).join(' ');
        }
        const text = [prefix, amount, this.dataset.suffix].filter(Boolean).join(' ');
        if (this.badge.textContent !== text) this.badge.textContent = text;
        this.badge.hidden = false;
      }
    }

    customElements.define('casida-daily-price', CasidaDailyPrice);
  })();
  } catch(e) { console.error(e); }
})();

})();
